function parseServerErrors(responseErrors, outResultErrors, outGenericErrors) {

    const serverErrors = responseErrors;

    if (Array.isArray(serverErrors)) {
        serverErrors.forEach((e) => {

            if (e != undefined && e.length > 0) {
                const msg = e.split('|');

                if (msg.length == 2) {
                    outResultErrors.push({
                        field: msg[0],
                        msg: msg[1],
                    });
                } else {
                    outGenericErrors.push(msg[0]);
                }
            }
        });
    } else {
        outGenericErrors.push(serverErrors);
    }
}

function parseExceptionMessage(exception) {
    if (!exception && !exception.response) {
      return '';
    }

    return Array.isArray(exception.response.data)
        ? exception.response.data.join(', ')
        : exception.response.data;
}

function updateErrorMessages(errors, batchResults, poError, manualPoError) {

  errors.forEach((error) => {
    if (error.field.startsWith('PN')) {

        const id = error.field.substring(2);
        var batchResult = batchResults.find(b => b.parameterNo == id);

        if (batchResult) {
          batchResult.error = {
            msg: error.msg,
          };
        }
    } else if (error.field.startsWith('PO')) {
      poError.msg = error.msg;
    } else if (error.field.startsWith('MBN')) {
      manualPoError.msg = error.msg;
    }

  });
}

export default { parseServerErrors, updateErrorMessages }
